export default __webpack_public_path__ + "static/media/poster-not-found.2a23ac2a.jpg";